import React from "react";
import MarkdownIt from "markdown-it";
import Emojis from "markdown-it-emoji";
import Superscript from "markdown-it-sup";
import Subscript from "markdown-it-sub";
import Mark from "markdown-it-mark";
import Footnote from "markdown-it-footnote";
import hljs from "highlightjs";

const MarkdownContainer = ({
  ariaLabel,
  className,
  children,
  markdown,
  onClick,
  placeholder,
  tabIndex,
  id
}) => {
  const _keyUp = e => {
    if (e.keyCode === 13) {
      onClick();
    }
  };

  let __html = MarkdownIt({
    linkify: true,
    typographer: true,
    breaks: true,
    highlight: (str, lang) => {
      if (lang && hljs.getLanguage(lang)) {
        try {
          return (
            '<pre class="hljs"><code>' +
            hljs.highlight(lang, str, true).value +
            "</code></pre>"
          );
        } catch (__) {}
      }

      return (
        '<pre class="hljs"><code>' +
        MarkdownIt().utils.escapeHtml(str) +
        "</code></pre>"
      );
    }
  });

  __html.renderer.rules.table_open = () =>
    '<table class="table table-striped">\n';
  __html.renderer.rules.link_open = link => {
    let i = link.findIndex(l => l.type === "link_open");
    link[i].attrs.push(["target", "_blank"]);
    let result = "<a ";
    link[i].attrs.forEach(attr => {
      result += attr[0] + "=" + attr[1] + " ";
    });
    result.trim();
    result += ">\n";
    return result;
  };

  __html
    .use(Emojis)
    .use(Superscript)
    .use(Subscript)
    .use(Footnote)
    .use(Mark);

  const _onClick = e => {
    e.target.nodeName !== "A" && onClick();
  };

  return (
    <div
      className={className}
      dangerouslySetInnerHTML={{ __html: __html.render(markdown) }}
      onClick={_onClick}
      onKeyUp={_keyUp}
      placeholder={placeholder}
      tabIndex={tabIndex}
      id={id}
    />
  );
};

MarkdownContainer.defaultProps = {
  ariaLabel: "",
  className: "",
  markdown: "",
  onClick: () => {},
  placeholder: "",
  tabIndex: -1,
  id: ""
};

export default MarkdownContainer;
